export const iconFontAwesomeUsersPeoplePersonHarassing = (
	<i className="fa-solid fa-person-harassing"></i>
);
